const compareColor = (a, b) => {
    const colorLevel = {
        'BLACK': 1,
        'WHITE': 2,
        'RED': 3,
        'NAVY': 4,
        'SPORT GREY': 5
    }
    const levelA = colorLevel[a] || 0
    const levelB = colorLevel[b] || 0

    if (levelA > levelB) return 1
    if (levelA < levelB) return -1
    if (a > b) return 1
    if (a < b) return -1

    return 0
}

export default compareColor
